import { useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const role = localStorage.getItem("verificationRole");

    if (role === "admin") {
      // ✅ redirect to ADMIN VERIFICATION HANDLER
      navigate(`/admin/verify-handler/${token}`, { replace: true });
    } else {
      // ✅ normal user flow
      navigate(`/?verifyToken=${token}`, { replace: true });
    }
  }, [token, navigate]);

  return <div>Verifying...</div>; // 🔴 NEVER return null
};

export default VerifyEmail;